import { Action, createAction } from "../../actions/Action";
import { wait } from "../../actions/ActionMovement";
import { Actor } from "../Actor";
import {
  bestMoveOrAttackPlayer,
  conditionalApproach,
  getAdjacentToPlayer,
  staggered,
  updateSeen,
} from "./aiHelpers";

export type ActionController = (actor: Actor) => Action<any> | void;

export const genericController = (actor: Actor) => {
  const visible = updateSeen(actor);

  let action: Action<any> | undefined | null = staggered(actor);
  if (action) {
    return action;
  }

  if (visible || actor.seenPlayer) {
    action = bestMoveOrAttackPlayer(actor);
    if (action) {
      return action;
    }
  }
  return createAction(wait, actor, null);
};

export const surroundController = (actor: Actor) => {
  const visible = updateSeen(actor);

  let action: Action<any> | undefined = staggered(actor);
  if (action) {
    return action;
  }

  if (visible || actor.seenPlayer) {
    const adj = getAdjacentToPlayer(actor);
    action = conditionalApproach(actor, 3, 0 < adj.length);
    if (action) {
      return action;
    }
  }
  return createAction(wait, actor, null);
};

export const onlyIfTypeAdjacentController = (actor: Actor) => {
  const visible = updateSeen(actor);

  let action: Action<any> | undefined = staggered(actor);
  if (action) {
    return action;
  }

  if (visible || actor.seenPlayer) {
    const adj = getAdjacentToPlayer(actor);
    action = conditionalApproach(
      actor,
      2,
      0 < adj.length &&
        adj.find((a) => a.breed === actor.controllerProps.aggressor) != null
    );
    if (action) {
      return action;
    }
  }
  return createAction(wait, actor, null);
};
